import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Box from '@material-ui/core/Box'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import AddOutlined from '@material-ui/icons/AddOutlined'
import Close from '@material-ui/icons/Close'
import Remove from '@material-ui/icons/Remove'
import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import colorContext from '../../Context/colorContext'

interface ListProps {
  nome: string
  route_name?: string
  list: [
    {
      id: number
      titulo: string
      url: string
      slug?: string
      isExternal: boolean
      pagina_slug: string
      pagina_publicado: boolean
    },
  ]
}

interface DrawerMenuProps {
  isOpen: boolean
  handleOpenDrawerNav: () => void
  navigationList: ListProps[]
}

const DrawerMenu = ({
  isOpen,
  handleOpenDrawerNav,
  navigationList,
}: DrawerMenuProps): JSX.Element => {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    drawerActions: {
      top: 224,
      height: 'calc(100vh - 210px)',
      backgroundColor: colors.colorBackgroundSecundary,
    },
    titleDrawer: {
      margin: '24px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    textDrawer: {
      fontFamily: 'Roboto',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    accordionRoot: {
      backgroundColor: colors.colorBackgroundSecundary,
      border: 'none',
      padding: '0px 20px',
    },
    listDrawer: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      color: colors.textAccentColor,
      marginLeft: 10,
      textTransform: 'uppercase',
    },
    listAcordeons: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    accordion: {
      '&.MuiAccordion-root:before': {
        backgroundColor: 'transparent',
      },
    },
    accordionDetails: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: colors.colorBackground,
    },
    boxLinksMobile: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 20,
    },
    linksMobile: {
      textDecoration: 'none',
      marginLeft: 8,
      color: colors.textBody,
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      fontFamily: 'Roboto',
    },
  }))
  const classes = useStyles()
  const [expanded, setExpanded] = useState('panel0')

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <Drawer anchor="bottom" open={isOpen}>
      <Box className={classes.drawerActions}>
        <Box className={classes.titleDrawer}>
          <Typography className={classes.textDrawer}>Menu</Typography>
          <IconButton onClick={handleOpenDrawerNav}>
            <Close style={{ color: '#fff', fontSize: 30 }} />
          </IconButton>
        </Box>
        <Box>
          {navigationList.length > 0 &&
            navigationList.map((navigate, index) => (
              <Accordion
                key={`${index}-key-${navigate.nome}`}
                expanded={expanded === `painel${index}`}
                onChange={handleChange(`painel${index}`)}
              >
                <AccordionSummary
                  classes={{ root: classes.accordionRoot }}
                  expandIcon={
                    expanded === `painel${index}` ? (
                      <Remove style={{ color: colors.accentColor }} />
                    ) : (
                      <AddOutlined style={{ color: colors.accentColor }} />
                    )
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className={classes.listAcordeons}>
                    <Typography className={classes.listDrawer}>
                      {navigate.nome}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionDetails}>
                  {navigate?.list?.length > 0 &&
                    navigate.list.map((linkList, index) => (
                      <div
                        key={`${linkList.id}-key-${index}`}
                        className={classes.boxLinksMobile}
                      >
                        {!navigate.route_name ? (
                          <a
                            className={classes.linksMobile}
                            href={
                              linkList.isExternal || linkList.url
                                ? linkList.url
                                : `${process.env.PUBLIC_URL}/pagina/${linkList.pagina_slug}`
                            }
                            target={linkList.isExternal ? '_blank' : '_self'}
                            rel="noreferrer"
                          >
                            {linkList.titulo}{' '}
                          </a>
                        ) : (
                          <Link
                            to={`/${navigate.route_name}/servicos/${linkList.slug}/categoria/${linkList.id}`}
                            className={classes.linksMobile}
                            onClick={handleOpenDrawerNav}
                          >
                            {linkList.titulo}
                          </Link>
                        )}
                      </div>
                    ))}
                </AccordionDetails>
              </Accordion>
            ))}
        </Box>
      </Box>
    </Drawer>
  )
}

export default DrawerMenu
